import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import { BattleState, SetBattleContentAction } from './interface';

const initialState: BattleState = {
  content: [],
};

export const { actions, reducer } = createSlice({
  name: 'battle',
  initialState,
  reducers: {
    setBattleContent(state, action: SetBattleContentAction) {
      state.content = action.payload.content;
    },
  },
});

export { reducer as battleReducer, actions as battleActions };

export const battleSelector = (state: RootState) => state.battle;
